import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { BusMessageChannels, BusMessageService } from '../../services/bus-message.service';
import { UserService } from '../../services/user.service';
import { ILinkedPropertyData, LinkedPropertyUtility } from '../../../../shared/utils/linked-property.utility';
import { AiChatStateService } from './ai-chat-state.service';

@Injectable({ providedIn: 'root' })
export class AiChatNavigationService {
  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly busMessageService: BusMessageService,
    private readonly aiChatStateService: AiChatStateService,
  ) {}

  public navigateTo(href: string | null): boolean {
    let path: string | null = href;

    if (path && !path.startsWith('/')) {
      try {
        const url: URL = new URL(path);
        if (url.origin === window.location.origin) {
          path = url.pathname + url.search;
        }
      } catch {
        // not a valid absolute URL — fall through to the guard below
      }
    }

    if (!path?.startsWith('/')) {
      return false;
    }

    this.aiChatStateService.collapseAIChatPanel();

    const [, search] = path.split('?');
    const params: Record<string, string> = Object.fromEntries(new URLSearchParams(search || '').entries());
    const { digitalPropertyId, workspaceId }: ILinkedPropertyData = LinkedPropertyUtility.fromLinkedPropertyQueryParam(params);

    if (digitalPropertyId && workspaceId) {
      void this.userService
        .switchUserToDigitalProperty(workspaceId, digitalPropertyId)
        .pipe(take(1))
        .toPromise()
        .then(async () => this.router.navigateByUrl(path))
        .then(() => {
          this.busMessageService.to(BusMessageChannels.userSwitchedToDigitalProperty).next();
        });
    } else {
      this.router.navigateByUrl(path);
    }

    return true;
  }
}
